import React, { useMemo } from 'react';
import clsx from 'clsx';
import {
    Select,
    MenuItem,
    Typography,
    FormControl,
    InputLabel,
    Hidden,
} from '@material-ui/core';
import { Money } from '@paysera/money';
import PropTypes from 'prop-types';
import priceTypeShape from '%paysera_seat_selection_integration/js/seatings/propTypes/priceTypeShape';
import { localizeMoney } from '%app/js/common/services/localizeMoney';
import Translator from '%app/js/common/services/translator';

function PriceSelector({
    priceTypes,
    currency,
    currentHash,
    selectPriceType,
    classes,
}) {
    const currentPriceType = useMemo(() => priceTypes.find(item => (item.hash === currentHash)), [currentHash]);
    if (priceTypes.length === 1) {
        return (
            <React.Fragment>
                <Hidden mdUp>
                    <Typography
                        display="inline"
                        color="textSecondary"
                        variant="body2"
                        className={classes.mobileTitle}
                    >
                        {Translator.trans('seat_selection_integration.cart.price')}
                        {':'}
                    </Typography>
                </Hidden>
                <Typography
                    display="inline"
                    className={clsx({
                        [classes.singleTitle]: currentPriceType.description === null,
                    })}
                >
                    {`${localizeMoney(new Money(priceTypes[0].price, currency))} (${priceTypes[0].name})`}
                </Typography>
                {currentPriceType.description !== null && (
                    <Typography variant="subtitle2" color="textSecondary">
                        {currentPriceType.description}
                    </Typography>
                )}
            </React.Fragment>
        );
    }

    return (
        <FormControl fullWidth>
            <Hidden mdUp>
                <InputLabel>{Translator.trans('seat_selection_integration.cart.price')}</InputLabel>
            </Hidden>
            <Select
                onChange={({ target: { value } }) => selectPriceType(value)}
                value={currentHash}
                fullWidth
            >
                {priceTypes.map((priceType) => {
                    const price = new Money(priceType.price, currency);

                    return (
                        <MenuItem key={priceType.hash} value={priceType.hash}>
                            {`${localizeMoney(price)} (${priceType.name})`}
                        </MenuItem>
                    );
                })}
            </Select>
            <Typography variant="subtitle2" color="textSecondary">
                {priceTypes.find(item => (item.hash === currentHash)).description}
            </Typography>
        </FormControl>
    );
}

PriceSelector.propTypes = {
    priceTypes: PropTypes.arrayOf(PropTypes.shape(priceTypeShape)).isRequired,
    currency: PropTypes.string.isRequired,
    currentHash: PropTypes.string.isRequired,
    selectPriceType: PropTypes.func.isRequired,
    classes: PropTypes.shape({
        singleTitle: PropTypes.string,
        mobileTitle: PropTypes.string,
    }).isRequired,
};

export default PriceSelector;
